import Vue from 'vue';
import DomainExpiredComponent from './index.vue';

const DomainExpiredConstructor = Vue.extend(DomainExpiredComponent);

let instance;

const DomainExpired = function() {
  if (Vue.prototype.$isServer) return;
  
  if (!instance) {
    instance = new DomainExpiredConstructor({
      el: document.createElement('div')
    });
    document.body.appendChild(instance.$el);
  }
  
  // 使用组件内的方法来显示
  instance.show();
  
  return instance;
};

export default DomainExpired;
